<template>
  <div class="footer" v-if="screenWidth >= 840">
    <div class="footer_div">
      <div class="center">
        <div class="table">
          <!-- 产品介绍列 -->
          <div class="col">
            <div class="cell header">{{ $t("menu.products") }}</div>
            <el-tooltip
              v-for="(product, index) in products"
              :key="'p-' + index"
              :content="product.name" :disabled="!tooltipEnabled['p-'+index]"
              placement="top"
              effect="light" popper-class="footer-tooltip"
            >
              <div
                class="cell"
                @mouseenter="checkEllipsis($event, 'p-'+index)"
                @click="goTo('/AllProducts', product.name)"
              >
                {{ product.name }}
              </div>
            </el-tooltip>
          </div>

          <!-- 按需订阅列：只显示 showSubscribe=Y 的 -->
          <div class="col">
            <div class="cell header">{{ $t("menu.buy") }}</div>
            <el-tooltip
              v-for="(product, index) in products.filter(p => p.buyLink)"
              :key="'b-' + index"
              :content="product.buyLink" :disabled="!tooltipEnabled['b-'+index]"
              placement="top"
              effect="light" popper-class="footer-tooltip"
            >
              <div
                class="cell"
                @mouseenter="checkEllipsis($event, 'b-'+index)"
                @click="down('/Buy', product)"
              >
                {{ product.buyLink }}
              </div>
            </el-tooltip>
          </div>

          <!-- 免费软件列 -->
          <div class="col">
            <div class="cell header">{{ $t("menu.freeSoft") }}</div>
            <el-tooltip
              v-for="(product, index) in products"
              :key="'f-' + index"
              :content="product.freeLink || ''" :disabled="!tooltipEnabled['f-'+index]"
              placement="top"
              effect="light" popper-class="footer-tooltip"
            >
              <div
                class="cell"
                @mouseenter="checkEllipsis($event, 'f-'+index)"
                @click="product.freeLink && down('/freeSoft', product)"
              >
                {{ product.freeLink || "" }}
              </div>
            </el-tooltip>
          </div>

          <!-- 服务支持列 -->
          <div class="col">
            <div class="cell header">{{ $t("menu.service") }}</div>
            <el-tooltip
              v-for="(service, index) in services"
              :key="'s-' + index"
              :content="service.text" :disabled="!tooltipEnabled['s-'+index]"
              placement="top"
              effect="light" popper-class="footer-tooltip"
            >
              <div
                class="cell"
                @mouseenter="checkEllipsis($event, 's-'+index)"
                @click="goToService('/Service', service.type)"
              >
                {{ service.text }}
              </div>
            </el-tooltip>
          </div>

          <!-- 关于我们列 -->
          <div class="col">
            <div class="cell header">{{ $t("menu.about") }}</div>
            <el-tooltip
              v-for="(about, index) in abouts"
              :key="'a-' + index"
              :content="about.text" :disabled="!tooltipEnabled['a-'+index]"
              placement="top"
              effect="light" popper-class="footer-tooltip"
            >
              <div
                class="cell"
                @mouseenter="checkEllipsis($event, 'a-'+index)"
                @click="goTo('/AboutUs', about.link)"
              >
                {{ about.text }}
              </div>
            </el-tooltip>
          </div>
        </div>
      </div>

      <div class="right">
        <div>
          <el-tooltip content="扫码不成功请在对应平台进行搜索" placement="top" effect="light" popper-class="footer-tooltip">
            <img src="@/assets/image/二维码.png" alt="" />
          </el-tooltip>
          <el-tooltip :content="$t('footer.wechatPlatform')" :disabled="!tooltipEnabled['qr1']" placement="top" effect="light" popper-class="footer-tooltip">
            <p @mouseenter="checkEllipsis($event, 'qr1')">{{ $t("footer.wechatPlatform") }}</p>
          </el-tooltip>
        </div>
        <div>
          <el-tooltip content="扫码不成功请在对应平台进行搜索" placement="top" effect="light" popper-class="footer-tooltip">
            <img src="@/assets/image/二维码2.png" alt="" />
          </el-tooltip>
          <el-tooltip :content="$t('footer.officialVideo')" :disabled="!tooltipEnabled['qr2']" placement="top" effect="light" popper-class="footer-tooltip">
            <p @mouseenter="checkEllipsis($event, 'qr2')">{{ $t("footer.officialVideo") }}</p>
          </el-tooltip>
        </div>
        <div>
          <el-tooltip content="扫码不成功请在对应平台进行搜索" placement="top" effect="light" popper-class="footer-tooltip">
            <img src="@/assets/image/二维码.8262d8c8.png@3x.png" alt="" />
          </el-tooltip>
          <el-tooltip :content="$t('footer.douyingVideo')" :disabled="!tooltipEnabled['qr3']" placement="top" effect="light" popper-class="footer-tooltip">
            <p @mouseenter="checkEllipsis($event, 'qr3')">{{ $t("footer.douyingVideo") }}</p>
          </el-tooltip>
        </div>
      </div>
    </div>

    <div class="div_e">{{ $t("footer.icp") }}</div>
  </div>
</template>

<script>
import { family, freeSoftList } from "@/assets/API/pay";

export default {
  data() {
    return {
      screenWidth: document.body.clientWidth,
      // 记录每个条目是否被截断（出现省略号），仅截断时才启用悬浮全称
      tooltipEnabled: {},

      products: [],

      services: [
        { text: this.$t("footer.softwareSupport"), type: "update" },
        { text: this.$t("footer.qa"), type: "feedback" },
        { text: this.$t("footer.customerService"), type: "contact" },
      ],

      abouts: [
        { text: this.$t("footer.companyIntro"), link: "intro" },
        { text: this.$t("footer.culture"), link: "culture" },
        { text: this.$t("footer.honors"), link: "qualifications" },
        { text: this.$t("footer.contactUs"), link: "aboutmap" },
      ],
    };
  },

  mounted() {
    window.onresize = () => {
      this.screenWidth = document.body.clientWidth;
    };

    this.loadFooterProducts();
  },

  methods: {
    // 鼠标移入时检测文本是否被截断（scrollWidth > clientWidth 即出现了省略号）
    checkEllipsis(event, key) {
      const el = event.currentTarget;
      this.$set(this.tooltipEnabled, key, el.scrollWidth > el.clientWidth + 1);
    },

    async loadFooterProducts() {
      try {
        const [productsRes, freeRes] = await Promise.all([
          family(),
          freeSoftList(),
        ]);

        const productList = productsRes?.data || [];
        const freeList = freeRes?.data || [];

        this.products = productList.map((product, index) => {
          const freeItem = freeList[index];
          const val = product?.showSubscribe;
          const canSubscribe = ![false, "false", "FALSE", "N", "n", 0, "0"].includes(val);

          return {
            id: product.id,
            familyCode: product.familyCode || product.softCode,
            name: product.familyCode || product.softCode,
            buyLink: canSubscribe ? (product.familyCode || product.softCode) : "",
            freeLink: freeItem?.softCode || "",
            freeId: freeItem?.id || "",
          };
        });
      } catch (err) {
        console.error("加载底部产品数据失败:", err);

        this.products = [
          {
            id: "",
            familyCode: "SummitMap",
            name: "SummitMap",
            buyLink: "SummitMap",
            freeLink: "SummitView",
          },
          {
            id: "",
            familyCode: "SummitSolid",
            name: "SummitSolid",
            buyLink: "SummitSolid",
            freeLink: "SummitLab",
          },
          {
            id: "",
            familyCode: "SummitLab",
            name: "SummitLab",
            buyLink: "SummitLab",
            freeLink: "",
          },
        ];
      }
    },

    goTo(url, value) {
      if (value) {
        this.$router.push({
          path: url,
          query: {
            familyCode: value,
          },
        });
      } else {
        this.$router.push({
          path: url,
        });
      }
    },

    down(url, data) {
      this.$router.push({
        path: url,
        query: {
          familyCode: data.familyCode || data.name || data.buyLink,
          productId: data.id || data.freeId || "",
        },
      });
    },

    goToService(path, type) {
      this.$router.push({
        path,
        query: {
          type,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.footer {
  width: 100%;
  background: #fff;
  color: #333;

  .footer_div {
    width: 100%;
    max-width: 1350px;
    margin: 0 auto;
    padding: 48px 20px 36px;
    box-sizing: border-box;

    display: flex;
    align-items: flex-start;
    justify-content: center;
    gap: 40px;
  }

  .center {
    flex: 1;
    min-width: 0;
    height: auto;

    .table {
      width: 100%;
      display: flex;
      align-items: flex-start;
      gap: 0;
    }

    .col {
      flex: 1;
      min-width: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .cell {
      width: 100%;
      height: 42px;
      padding: 4px 8px;
      box-sizing: border-box;

      display: flex;
      align-items: center;
      justify-content: center;

      line-height: 22px;
      cursor: pointer;
      color: #666;
      font-size: 14px;
      text-align: center;
      word-break: keep-all;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      transition: color 0.2s;

      &:hover {
        color: #2b85e5;
      }
    }

    .cell.header {
      min-height: 46px;
      font-weight: bold;
      color: #000 !important;
      font-size: 15px;
      cursor: default;
      &:hover {
        color: #000 !important;
      }
    }
  }

  .right {
    width: 360px;
    min-height: 250px;
    height: auto;
    color: #666;

    display: flex;
    align-items: flex-start;
    justify-content: center;
    gap: 24px;

    padding-left: 0;
    box-sizing: border-box;

    div {
      width: 100px;
      text-align: center;
      margin-right: 0;
    }

    img {
      width: 100px;
      height: 100px;
      object-fit: contain;
      image-rendering: -webkit-optimize-contrast;
    }

    p {
      margin: 8px 0 0;
      text-align: center;
      color: #666;
      font-size: 14px;
      line-height: 1.4;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .div_e {
    width: 100%;
    border-top: 1px solid #e4e4e4;
    padding: 16px 0;
    box-sizing: border-box;

    font-size: 14px;
    letter-spacing: 0;
    color: #000;
    text-align: center;
    line-height: 22px;
  }

  td {
    cursor: pointer;
  }
}

@media screen and (max-width: 1200px) {
  .footer {
    .footer_div {
      max-width: 100%;
      gap: 24px;
    }

    .center {
      .table {
        grid-template-columns: repeat(5, minmax(100px, 1fr));
      }

      .cell {
        font-size: 13px;
        padding: 4px 6px;
      }
    }

    .right {
      width: 320px;
      gap: 16px;

      div {
        width: 90px;
      }

      img {
        width: 90px;
        height: 90px;
      }

      p {
        font-size: 12px;
      }
    }
  }
}

@media screen and (max-width: 840px) {
  .footer {
    flex-direction: column;
    color: #000;

    .footer_top {
      display: flex;
      align-items: center;

      .logo {
        width: 28%;
        object-fit: contain;
        display: block;
        margin-right: 33px;
      }

      ul {
        min-width: 43%;
        list-style: none;
        display: block;
      }
    }

    .footer_top_right {
      img {
        width: 44%;
        display: block;
        margin: 0 auto;
      }

      p {
        text-align: center;
        font-size: 12px;
      }
    }

    .footer_bottom {
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      flex-wrap: nowrap;
      font-size: 16px;
      list-style: none;
      margin-bottom: 26px;
      cursor: pointer;
    }
  }
}
</style>

<style lang="scss">
/* 页脚悬浮全称遮罩：浅色卡片样式（popper 挂载在 body 下，不能用 scoped） */
.el-tooltip__popper.footer-tooltip {
  background: #fff;
  color: #333;
  border: 1px solid #e4e9f0;
  border-radius: 8px;
  box-shadow: 0 6px 20px rgba(26, 43, 75, 0.12);
  padding: 8px 14px;
  font-size: 13px;
  line-height: 1.6;
  max-width: 300px;
  white-space: normal;
  word-break: break-all;

  &[x-placement^="top"] .popper__arrow {
    border-top-color: #e4e9f0;
  }
  &[x-placement^="top"] .popper__arrow::after {
    border-top-color: #fff;
  }
}
</style>
